<template>
  <footer class="p-relative">
    <div class="divider">
      <svgDivider fillColor="#1a0e25"/>
    </div>
    <div class="container grid-xl p-relative">
      <div class="columns">
        <div class="column col-xl-12">
          <h3>TERMS</h3>
          <p>
           <small>
             Sed urna mi, ornare ac hendrerit eu, mattis et velit. Vivamus id viverra enim. Vivamus sit amet viverra elit, sollicitudin rhoncus ante. Pellentesque faucibus tempor ligula vulputate rhoncus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras pharetra enim ac aliquam pretium. Donec interdum varius varius
           </small>
          </p>
          <p class="footer_inf">
            <small>
              &copy;{{getYear()}} - <a href="http://www.potatosites.com/">www.potatosites.com</a>
            </small>
          </p>
        </div>
      </div>
      <topButton :backColor="true"/>
    </div>
  </footer>
</template>

<script>
import topButton from './topButton'
import svgDivider from './svg_icons/svgDivider';
export default {
  name: 'FooterSection',
  components: {
    topButton,
    svgDivider
  },
  methods: {
    getYear(){
      let d = new Date();
      return d.getFullYear();
    }
  }
}
</script>

<style scoped lang="scss">
footer small{
  font-size: 70%;
}
.go_top_btn{
  position: absolute;
  right: 1rem;
  bottom: -75px;
}
.footer_inf{
  color: $gray-500;
  a{
    transition: color 0.2s linear;
    color: inherit;
    &:hover{
      color: lighten($dirty-vel, 25);
    }
  }
}
</style>
